import type { FC } from "react"
import { useQuery } from "urql"

import { GetCompanyProductAssociationListDocument } from "@/graphql/codegen/graphql"
import { AssociationLocationDialog } from "@/screens/CustomerProducts/components/ProductApprovalPerLocation/AssociationLocationDialog"

interface QuotedProductLocationAssociationDialogProps {
  companyId: string
  productId: number
  shipToLocationId: string
  onClose: (shouldRefetch?: boolean) => void
}

export const QuotedProductLocationAssociationDialog: FC<QuotedProductLocationAssociationDialogProps> = ({
  companyId,
  productId,
  shipToLocationId,
  onClose,
}) => {
  const [{ data }] = useQuery({
    query: GetCompanyProductAssociationListDocument,
    variables: { input: { companyId, limit: 1, filter: { productId } } },
  })

  const association = data?.companyProductAssociation?.list?.items[0]

  if (!association) return null

  return (
    <AssociationLocationDialog
      companyProductAssociationId={association.companyProductAssociationId}
      companyId={companyId}
      productId={productId}
      customerCodes={association.customerCode ?? []}
      initialShipToLocationId={shipToLocationId}
      onClose={() => onClose()}
      onSuccess={() => onClose(true)}
    />
  )
}
